<template>
  <div class="stock-approve">
    <!-- tab -->
    <ContentHeader :stock-nav="true" :show-back="false" />

    <div class="content-container">
      <!-- tab -->
      <div class="query-panel cards" v-loading="loading">
        <div
          :class="approveType === '01' ? 'activate' : ''"
          @click="approveType = '01'"
        >
          待审核
        </div>
        <div
          :class="approveType === '02' ? 'activate' : ''"
          @click="approveType = '02'"
        >
          已审核
        </div>
        <!-- <div
          :class="approveType === '03' ? 'activate' : ''"
          @click="approveType = '03'"
        >
          全 部
        </div> -->
      </div>

      <!-- 查询条件 -->
      <div class="query-panel">
        <div class="btn-line btn-line-right">
          <el-button
            v-if="approveType === '02'"
            class="btn-orange-plain"
            @click="handleExport()"
            size="small"
            >已审核明细下载</el-button
          >
        </div>
        <el-form
          :model="queryParam"
          label-position="right"
          label-width="100px"
          size="small"
          class="query-form"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="订单编号">
                <el-input
                  v-model="queryParam.applyNumber"
                  placeholder="请输入订单编号"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品名称">
                <el-input
                  v-model="queryParam.itemName"
                  placeholder="请输入商品名称"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品编码">
                <el-input
                  v-model="queryParam.itemCode"
                  placeholder="请输入商品编码"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="下单人">
                <el-input
                  v-model="queryParam.clientName"
                  placeholder="请输入下单人姓名"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="收货人">
                <el-input
                  v-model="queryParam.receivePerson"
                  placeholder="请输入收货人姓名"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所在仓库">
                <el-select
                  v-model="queryParam.warehouseId"
                  placeholder="请选择所在仓库"
                  clearable
                >
                  <el-option
                    v-for="option in warehouseList"
                    :key="option.key"
                    :label="option.warehouseName"
                    :value="option.warehouseId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8" v-if="approveType !== '01'">
              <el-form-item label="订单状态">
                <el-select
                  v-model="queryParam.applyStatus"
                  placeholder="请选择订单状态"
                  clearable
                >
                  <el-option
                    v-for="option in applyStatusList"
                    :key="option.key"
                    :label="option.value"
                    :value="option.key"
                  />
                </el-select>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="是否自提">
                <el-select
                  v-model="queryParam.isSelfDelivery"
                  placeholder="请选择是否自提"
                  clearable
                >
                  <el-option label="自提" value="1" />
                  <el-option label="非自提" value="0" />
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="9">
              <el-form-item label="查询日期">
                <el-col :span="11">
                  <el-date-picker
                    v-model="queryParam.fromDate"
                    type="date"
                    placeholder="开始日期"
                    value-format="yyyy-MM-dd"
                    class="form-date-item"
                    @change="startTimeStatus"
                    :picker-options="pickerOptionsStart"
                  />
                </el-col>
                <el-col class="text-center" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="queryParam.toDate"
                    type="date"
                    placeholder="截止日期"
                    value-format="yyyy-MM-dd"
                    class="form-date-item"
                    @change="endTimeStatus"
                    :picker-options="pickerOptionsEnd"
                  />
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="btn-line">
          <el-button class="btn-blue-plain" @click="searchQuery" size="small"
            >查询</el-button
          >
          <el-button class="btn-grey-plain" @click="resetQuery" size="small"
            >重置</el-button
          >
        </div>
      </div>
      <!-- 批量审核 -->
      <div
        class="query-panel"
        style="padding-top:10px;"
        v-show="approveType === '01' && this.stockApproveList"
      >
        <el-button class="btn-red-plain" @click="showApproveDialog" size="small"
          >批量审核</el-button
        >
      </div>
      <!-- 数据显示 -->
      <div class="table-show" v-loading="loading">
        <el-table
          :data="stockApproveList"
          class="while-data-table"
          @selection-change="handleSelectChange"
        >
          <!-- 勾选 批量审核 -->
          <el-table-column
            type="selection"
            width="50"
            v-if="approveType === '01' && this.stockApproveList"
          />

          <!-- 订单信息 -->
          <el-table-column
            prop="applyNumber"
            label="订单编号"
          ></el-table-column>
          <el-table-column label="订单时间">
            <template slot-scope="scope">
              {{ scope.row.applyDate | parseTime("{y}-{m}-{d}") }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="applyStatusName"
            label="订单状态"
          ></el-table-column> -->
          <!-- <el-table-column label="自提" width="50">
            <template slot-scope="scope">
              {{
                scope.row.isSelfDelivery === 1
                  ? "是"
                  : scope.row.isSelfDelivery === 0
                  ? "否"
                  : ""
              }}
            </template>
          </el-table-column> -->
          <el-table-column prop="clientName" label="下单人"></el-table-column>
          <el-table-column
            prop="receivePerson"
            label="收货人"
          ></el-table-column>
          <!-- <el-table-column
            prop="receivePhone"
            label="联系电话"
          ></el-table-column> -->
          <!-- <el-table-column
            prop="applyRemark"
            label="备注"
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column
            prop="purposeInfo"
            label="用途信息"
            show-overflow-tooltip
          ></el-table-column>
          <!-- 折叠商品信息 -->
          <el-table-column type="expand" width="60" label="商品信息">
            <template slot-scope="scope">
              <el-table
                :data="scope.row.stockApplyDetailList"
                class="delivery-table"
              >
                <el-table-column
                  label="商品名称"
                  align="center"
                  prop="itemName"
                />
                <el-table-column
                  label="商品编码"
                  align="center"
                  prop="itemCode"
                />
                <el-table-column
                  label="所在仓库"
                  align="center"
                  prop="warehouseName"
                />
                <el-table-column label="区域编码 - 名称" align="center">
                  <template slot-scope="scope">
                    <span
                      >{{ scope.row.orgCode }} - {{ scope.row.orgName }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column label="品牌部门编码 - 名称" align="center">
                  <template slot-scope="scope">
                    <span
                      >{{ scope.row.buType }} - {{ scope.row.buTypeName }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  width="50"
                  prop="specParam"
                  label="箱规"
                ></el-table-column>
                <el-table-column
                  label="数量"
                  align="center"
                  width="100"
                  prop="itemQuantity"
                />
                <el-table-column label="数量修改" width="80" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.beforeQuantity ? "是" : "否" }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="approveType === '01'"
                  label="历史申请数量"
                  align="center"
                  width="100"
                  prop="appliedQuantity"
                />
              </el-table>
            </template>
          </el-table-column>
          <el-table-column
            clign="center"
            label="操作"
            width="200"
            class-name="small-padding"
          >
            <template slot-scope="scope">
              <div style="line-height: 35px;">
                <!-- <el-button
                  type="primary"
                  size="mini"
                  v-if="scope.row.applyStatus === 100"
                  @click="showApproveDialog(scope.row)"
                  >审核</el-button
                > -->
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleShow(scope.row)"
                  >查看</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  v-if="approveType === '01'"
                  @click="handleHistoryShow(scope.row)"
                  >金额汇总</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div>
        <el-row class="while-data-table-footer">
          <el-col>
            <el-pagination
              background
              :current-page="queryParam.page"
              :page-size="queryParam.pageSize"
              :total="total"
              layout="total, prev, pager, next"
              @current-change="handleCurrentChange"
            />
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 审核弹框 -->
    <approveDialog
      ref="approve-dialog"
      @success="approveSuccess"
      :selected-items="selectedItems"
    ></approveDialog>

    <!-- 历史金额汇总弹框 -->
    <el-dialog
      title="历史申请单金额汇总"
      :visible.sync="amountDialogVisible"
      width="50%"
    >
      <el-row style="margin-bottom:15px;">
        <p style="margin:0;">下单人：{{ historyClientName }}</p>
      </el-row>
      <el-table
        size="mini"
        :data="amountHistoryInfo"
        border
        fit
        highlight-current-row
        style="width: 100%,max-height:30px;"
      >
        <el-table-column label="年月" align="center" prop="stockApplyMonth" />
        <el-table-column label="总花费" align="center">
          <template slot-scope="scope">
            <span>￥ {{ scope.row.stockApplyQuantity }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="btn-red-plain"
          size="small"
          @click="amountDialogVisible = false"
          >关闭</el-button
        >
      </div>
    </el-dialog>
    <v-form ref="form" :url="exportUrl" :params="exportParam" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ContentHeader from '@/components/content-header'
import approveDialog from './components/approve-dialog'
import { commonUtils } from '@/utils/common'
import vForm from '@/components/v-form'
export default {
  name: 'stock-approve',
  components: {
    ContentHeader,
    approveDialog,
    vForm
  },
  data () {
    return {
      loading: false,
      historyClientName: '',
      amountDialogVisible: false,
      amountHistoryInfo: [],
      approveType: '01', // 01待审核，02已审核，03全部
      warehouseList: [],
      exportParam: {},
      exportUrl: null,
      selectedItems: [],
      queryParam: {
        page: 1,
        pageSize: 10,
        applyNumber: '',
        itemCode: '',
        warehouseId: '',
        applyStatus: '',
        applyStatusType: '',
        fromDate: '',
        toDate: '',
        isSelfDelivery: '',
        itemName: '',
        receivePerson: '',
        clientName: ''
      },
      stockApproveList: [],
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      total: 0
    }
  },
  computed: {
    ...mapState({
      applyStatusList: state => state.base.stockApplyOrderStatusMap
    })
  },
  watch: {
    approveType (val) {
      this.queryParam.page = 1
      this.getStockApproveList()
    }
  },
  activated () {
    this.getStockApproveList()
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$store.dispatch('getDictByName', 'stockApplyOrderStatusMap')
      this.getWarehouseList()
      this.getStockApproveList()
    },
    // 获取审核列表
    getStockApproveList () {
      this.queryParam.applyStatusType =
        this.approveType === '03' ? '' : this.approveType

      // 状态筛选选择待审核时 跳转到待审核的tab里
      if (this.queryParam.applyStatus === '100') {
        this.approveType = '01'
        this.queryParam.applyStatus = ''
      }
      // 已选择其他状态 跳转到待审核tab时，清空已选择状态
      if (this.queryParam.applyStatusType === '01') {
        this.queryParam.applyStatus = ''
      }

      this.loading = true
      this.$store
        .dispatch('getApplyOrderApproveList', this.queryParam)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.stockApproveList = res.data.resultData.stockApplyApprovalList
            this.total = res.data.resultData.pageInfo.totalCounts
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 勾选 批量审核
    handleSelectChange (selectedItemList) {
      this.selectedItems = []
      this.selectedItems = selectedItemList
    },

    // 展示审核弹框
    showApproveDialog () {
      if (this.selectedItems.length === 0) {
        this.$message.error('暂无可操作订单')
        return
      }
      this.$refs['approve-dialog'].show()
    },

    // 审核成功
    approveSuccess () {
      this.getStockApproveList()
    },
    // 导出
    handleExport () {
      this.exportUrl = commonUtils.getApiUrl('/stock/apply/approval/export')
      this.exportParam = Object.assign({}, this.queryParam)
      delete this.exportParam.page
      delete this.exportParam.pageSize
      this.$confirm('是否根据当前条件导出文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      })
        .then(() => {
          this.$refs.form.submit()
        })
        .catch(() => {})
    },
    // 查询
    searchQuery () {
      this.queryParam.page = 1
      this.getStockApproveList()
    },
    // 查看详情
    handleShow (row) {
      this.$router.push({
        path: '/stock/stock-apply-order/info',
        query: { applyId: row.applyId, type: 'approve' }
      })
    },
    // 查看历史金额汇总
    handleHistoryShow (row) {
      this.amountHistoryInfo = row.historyAmountList
      this.historyClientName = row.clientName
      this.amountDialogVisible = true
    },
    // 重置
    resetQuery () {
      this.queryParam = this.$options.data().queryParam
      this.getStockApproveList()
    },

    // 翻页
    handleCurrentChange (val) {
      this.queryParam.page = val
      this.getStockApproveList()
    },

    // 获取仓库列表
    getWarehouseList () {
      this.$store.dispatch('getWarehouseListAll').then(res => {
        this.warehouseList = res.data.resultData.warehouseList
      })
    },
    // 时间开始选择器
    startTimeStatus: function (value) {
      this.pickerOptionsEnd = {
        disabledDate: time => {
          let beginDateVal = this.queryParam.fromDate
          if (beginDateVal) {
            return (
              time.getTime() <= new Date(beginDateVal).getTime() - 86400000
            )
          }
        }
      }
    },
    // 时间结束选择器
    endTimeStatus: function (value) {
      this.pickerOptionsStart = {
        disabledDate: time => {
          let endDateVal = this.queryParam.fromDate
          if (endDateVal) {
            return time.getTime() >= new Date(endDateVal).getTime()
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-line {
  padding-top: 0;
  min-height: 32px;
}

.btn-line-right {
  text-align: right;
  margin-bottom: 10px;
}
.approve-radio {
  float: left;
  ::v-deep .el-radio-button__inner:hover {
    color: $base-grey;
  }
}
.iconzu19,
.el-icon-shopping-bag-1 {
  font-size: 22px;
  color: $base-plain;
  margin-left: 20px;
}
.item-image {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  border: 1px solid $base-grey;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  img {
    max-width: 95%;
    max-height: 95%;
    border: none;
    cursor: pointer;
  }
}

.cards {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-around;
  div {
    width: 20%;
    height: 33px;
    line-height: 33px;
    border: 1px solid #dcdfe6;
    border-radius: 50px;
    font-size: 13px;
    text-align: center;
    cursor: pointer;
  }

  div:hover {
    color: $base-red;
    border: 1px solid $base-red;
  }

  .activate,
  .activate:hover {
    background: $base-red;
    color: #fff;
    border: none;
  }
}

.delivery-table {
  ::v-deep th {
    background-color: $base-grey3;
    font-weight: 600;
    color: rgb(144, 147, 164);
  }
  ::v-deep td {
    border-bottom: none !important;
  }

  .receipt-image {
    width: 60px;
    height: 60px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
